module.exports = __webpack_public_path__ + "img/TwJsp.21413db5.svg";